import { ToolLoading } from '@procureai/uix/ai';
import { ReactNode } from 'react';

export type ChatLoadingIndicatorProps = {
  message: string;
};

export const ChatLoadingIndicator = ({ message }: ChatLoadingIndicatorProps): ReactNode => {
  return <ToolLoading label={message} />;
};
